import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=f57817d4&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=ts&"
export * from "./Notification.vue?vue&type=script&lang=ts&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=f57817d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57817d4",
  null
  
)

export default component.exports